import { DppSnackbar } from "../components/material/dpp-snackbar";

let snackbar: DppSnackbar | null = null;

function ensureSnackbar(): DppSnackbar {
  if (!snackbar) {
    snackbar = new DppSnackbar();
    document.body.appendChild(snackbar);
  }
  return snackbar;
}

export interface ToastOptions {
  isError?: boolean;
  /** Optional action button (e.g. "Undo", "View"). */
  action?: { label: string; onClick: () => void };
  /** Auto-dismiss delay; M3 default 4 s (longer when an action is present). */
  durationMs?: number;
}

/**
 * Shows a transient Material 3 snackbar at the bottom of the screen.
 *
 * Back-compatible: `toast("Saved")` and `toast("Failed", true)` still work; the
 * options form adds an action button and custom duration.
 */
export function toast(
  message: string,
  errorOrOptions: boolean | ToastOptions = false,
): void {
  const opts: ToastOptions =
    typeof errorOrOptions === "boolean"
      ? { isError: errorOrOptions }
      : errorOrOptions;
  ensureSnackbar().show({
    text: message,
    isError: opts.isError ?? false,
    action: opts.action,
    durationMs: opts.durationMs ?? (opts.action ? 6000 : 4000),
  });
}
